import React, { Fragment, useEffect } from 'react';
import logo from '../../../assets/images/logo.png';
import {
  Navbar,
  NavbarBrand,
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Button,
  Badge,
  Label,
  Input,
  FormGroup,
  Alert,
} from 'reactstrap';
import { GET_DOCUMENT_DETAILS_URL } from '../../../utils/APIEndpoints';
import {
  authHeader,
  loggedUserDetails,
} from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import { useState } from 'react';
import STEP_TWO_BUILD_DOCUMENT from '../createDocument/STEP_TWO_BUILD_DOCUMENT';
import { Link } from 'react-router-dom';
import CustomPageNotFound from '../../common/CustomPageNotFound';
import CustomLoader from '../../common/CustomLoader';
//Status Label
const documentStatusLabel = {
  Pending: 'warning',
  Accepted: 'success',
  Rejected: 'danger',
};


function PreviewDocument(props) {
  const {
    match: {
      params: { hyperlink = '' },
    },
  } = props;

  //State
  const [documentDetails, setDocumentDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const { agencyId: loggedAgency = '', role: loggedUserRole = '' } =
    loggedUserDetails();

  //Get Document Details
  const getDocumentDetails = async () => {
    try {
      setLoading(true);
      const options = {
        method: 'GET',
        url: GET_DOCUMENT_DETAILS_URL,
        headers: authHeader(),
        params: { serviceDomainURL: hyperlink },
      };
      const response = await API(options);
      let apiResponse = response.data;
      const { status } = apiResponse;
      if (status === 'Success') {
        setDocumentDetails(apiResponse.data);
        // setDocumentDetails({ ...apiResponse.data });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        console.log(data,"error");
        // Swal.fire(getAlert('error',data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Did Mount
  useEffect(() => {
    if (hyperlink) {
      getDocumentDetails();
    }
  }, [hyperlink]);

  const {
    agencyId = '',
    agencyServiceId = '',
    templatePlaceHolderValue = '',
    requiredDocuments = '',
    serviceAmount = 0,
    serviceDescription = '',
    serviceDomainURL = '',
    serviceName = '',
    status: documentStatus = '',
    documentType = '',
    locationCodeId = '',
    extraFee,
    formInstruction = '',
  } = documentDetails;
  const replstr = templatePlaceHolderValue?.replaceAll('\u0019', '');

  // const documentsList = JSON.parse(replstr || '[]'); - fixed for crasing for any junk data from backend
  let documentsList = [];
try {
  const parsed = JSON.parse(replstr || '[]');
  documentsList = Array.isArray(parsed) ? parsed : [];
} catch (e) {
  documentsList = [];
}

  const additionalDocumentsList = JSON.parse(requiredDocuments || '[]');
  const multichoiceDetails = JSON.parse(extraFee || '[]');

  let resCount = 0;

  let dataList = documentsList.map((item, index) => {
    const { elements = [] } = item;

    const elementItem = elements.map((i, ind) => {
      if (i.type != 'instruction') {
        resCount = resCount + 1;
      } else {
        resCount = resCount;
      }
      return { ...i, resCount: resCount };
    });
    return { ...item, elements: elementItem };
  });
  return (
    <Fragment>
      <Navbar fixed="top" color="light" light className="navbar-bg" expand="md">
        <NavbarBrand href="/">
          <img src={logo} alt="PayForm logo" />
        </NavbarBrand>
      </Navbar>
      <div>
        <Container>
          <Row>
            {loading ? (
              <Col md={12}>
                <center>
                  <CustomLoader loading={loading} />
                </center>
              </Col>
            ) : (
              <Fragment>
                {loggedUserRole === 'PayGov Admin' ||
                parseInt(loggedAgency) === parseInt(agencyId) ? (
                  <Fragment>
                    <Col md={8}>
                      <Card body>
                        {documentType === 'WebForm' && (
                          <>
                            {formInstruction ? (
                              <Alert color="info">
                                <div
                                  className="view ql-editor"
                                  dangerouslySetInnerHTML={{
                                    __html: formInstruction || '',
                                  }}
                                ></div>
                              </Alert>
                            ) : (
                              ''
                            )}
                            {dataList.map((val) =>
                              val.elements.map((f, order) => {
                                if (f.variableId == 5) {
                                  let findValue = multichoiceDetails?.find(
                                    (value) => value.feesId == f.feesId
                                  );
                                  f.multipleChoiceDetails =
                                    findValue?.multipleChoiceDetails;
                                }
                                return (
                                  <div className="mb-3">
                                    {[
                                      'text',
                                      'textarea',
                                      'date',
                                      'time',
                                      'number',
                                      'instruction',
                                      'maskedtextbox',
                                    ].includes(f.type) ? (
                                      <FormGroup>
                                        <Label>
                                          {/* {order + 1}. {f.label} */}
                                          {f?.resCount &&
                                          f?.type != 'instruction'
                                            ? f?.resCount + '.' + ' ' + f.label
                                            : ''}{' '}
                                        </Label>
                                        {f.type == 'instruction' ? (
                                          <>
                                            {f.placeholder ? (
                                              <div
                                                className="view ql-editor"
                                                dangerouslySetInnerHTML={{
                                                  __html: f.placeholder || '',
                                                }}
                                              ></div>
                                            ) : (
                                              ''
                                            )}
                                          </>
                                        ) : (
                                          <Input
                                            type={f.type}
                                            placeholder={f.placeholder}
                                          ></Input>
                                        )}
                                        {/* <Input
                                          type={f.type}
                                          placeholder={f.placeholder}
                                        ></Input> */}
                                      </FormGroup>
                                    ) : (
                                      ''
                                    )}
                                    {f.type == 'select' ? (
                                      <>
                                        {' '}
                                        <Label>
                                          {order + 1}.{f.label}
                                        </Label>{' '}
                                        <Input
                                          type={f.type}
                                          placeholder={f.placeholder}
                                        >
                                          {' '}
                                          {f.options.map((o) => (
                                            <option value={o.value}>
                                              {o.label}
                                            </option>
                                          ))}{' '}
                                        </Input>
                                      </>
                                    ) : (
                                      ''
                                    )}
                                    {f.type == 'radio' ? (
                                      <>
                                        <Label>
                                          {order + 1}.{f.label}
                                        </Label>
                                        {f.options.map((o, index) => (
                                          <>
                                            <Col sm={10}>
                                              <FormGroup check>
                                                <Label check>
                                                  <Input
                                                    type="radio"
                                                    id=""
                                                    name={f.uniqueId}
                                                  />
                                                  {o.label}
                                                </Label>
                                              </FormGroup>
                                            </Col>{' '}
                                          </>
                                        ))}
                                      </>
                                    ) : (
                                      ''
                                    )}

                                    {f.type === 'variable' ? (
                                      f.variableId == 1 ? (
                                        <>
                                          <Label>
                                            {order + 1}.{f.label}
                                          </Label>
                                          <Col sm={10}>
                                            <FormGroup check>
                                              <Label check>
                                                <Input
                                                  type="checkbox"
                                                  placeholder="Enter Count"
                                                />
                                                Select
                                              </Label>
                                            </FormGroup>
                                          </Col>
                                        </>
                                      ) : f.variableId == 5 ? (
                                        <>
                                          {' '}
                                          <Label>
                                            {order + 1}.{f.label}
                                          </Label>
                                          <Input type="select">
                                            <option value={''}>Select</option>
                                            {f?.multipleChoiceDetails?.map(
                                              (value) => {
                                                return (
                                                  <option value={value.fees}>
                                                    {value.labelName} - $
                                                    {parseFloat(
                                                      value.fees
                                                    ).toFixed(2)}
                                                  </option>
                                                );
                                              }
                                            )}
                                          </Input>
                                        </>
                                      ) : (
                                        <>
                                          <Label>
                                            {order + 1}.{f.label}
                                          </Label>
                                          <Input
                                            type="text"
                                            placeholder="Choose Variable"
                                          ></Input>
                                        </>
                                      )
                                    ) : (
                                      <> </>
                                    )}

                                    {f.type == 'checkbox' ? (
                                      <>
                                        <Label>
                                          {order + 1}.{f.label}
                                        </Label>
                                        {f.options.map((o, index) => (
                                          <>
                                            <Col sm={10}>
                                              <FormGroup check>
                                                <Label check>
                                                  <Input
                                                    type="checkbox"
                                                    id=""
                                                    name={f.uniqueId}
                                                  />
                                                  {o.label}
                                                </Label>
                                              </FormGroup>
                                            </Col>
                                          </>
                                        ))}
                                      </>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                );
                              })
                            )}
                          </>
                        )}
                        {documentType === 'Pdf' && (
                          <STEP_TWO_BUILD_DOCUMENT
                            isPreviewDocument={true}
                            documentsList={documentsList}
                          />
                        )}
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card>
                        <CardHeader>
                          {serviceName}
                          {loggedUserRole !== 'PayGov Admin' &&
                          documentStatus === 'New' ? (
                            <Button
                              tag={Link}
                              to={`/edit-document/${agencyServiceId}`}
                              className="action-btn"
                              color="info"
                              style={{ float: 'right' }}
                            >
                              Edit
                            </Button>
                          ) : (
                            <Badge
                              color={documentStatusLabel[documentStatus]}
                              style={{ color: '#fff', float: 'right' }}
                            >
                              {documentStatus}
                            </Badge>
                          )}
                        </CardHeader>
                        <CardBody>
                          <p>
                            {/* Description :<b> {serviceDescription}</b> */}
                            Description :{'  '}
                            {serviceDescription ? (
                              <div
                                className="view ql-editor"
                                dangerouslySetInnerHTML={{
                                  __html: serviceDescription || '',
                                }}
                              ></div>
                            ) : (
                              <b>-</b>
                            )}
                          </p>
                          <p>
                            Hyperlink :<b> {serviceDomainURL}</b>
                          </p>
                          {documentStatus === 'Accepted' && (
                            <p>
                              Approved Certificate Link :
                              <Link
                              className="link"
                                target="_blank"
                                to={`/s/${serviceDomainURL}`}
                              >
                                <b> /s/{serviceDomainURL}</b>
                              </Link>
                            </p>
                          )}
                          <p>
                            Document Fee :
                            <b>
                              {' '}
                              {serviceAmount == 0
                                ? '  -  '
                                : '$' + parseFloat(serviceAmount).toFixed(2)}
                            </b>
                          </p>
                          <p>
                            Location Code :<b>{locationCodeId}</b>
                          </p>
                          {additionalDocumentsList &&
                          additionalDocumentsList.length ? (
                            <Fragment>
                              <CardTitle>Additional Documents</CardTitle>
                              <Table responsive bordered>
                                <thead>
                                  <tr>
                                    <th>Document Name</th>
                                    <th>Description</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {additionalDocumentsList.map(
                                    ({ documentName, description }, index) => (
                                      <tr key={`add_list_${index}`}>
                                        <td>{documentName || '-'}</td>
                                        <td>{description || '-'}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            </Fragment>
                          ) : (
                            <CardTitle>
                              No additional documents are needed!
                            </CardTitle>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Fragment>
                ) : (
                  <Col md={12}>
                    <CustomPageNotFound />
                  </Col>
                )}
              </Fragment>
            )}
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}
export default PreviewDocument;
